import { render, staticRenderFns } from "./s_Signatures.vue?vue&type=template&id=f823b146&scoped=true&"
import script from "./s_Signatures.vue?vue&type=script&lang=js&"
export * from "./s_Signatures.vue?vue&type=script&lang=js&"
import style0 from "./s_Signatures.vue?vue&type=style&index=0&id=f823b146&prod&lang=css&"
import style1 from "./s_Signatures.vue?vue&type=style&index=1&id=f823b146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f823b146",
  null
  
)

export default component.exports